import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageProperties: {
    description: 'Header for the properties panel section in document designer',
    defaultMessage: 'Page Properties',
    id: 'Cc1DXZ',
  },
  size: {
    description: 'Label for the page size property',
    defaultMessage: 'Paper size',
    id: '31ZDo9',
  },
  displayMode: {
    description: 'Label for the display mode dropdown selector',
    defaultMessage: 'Display mode',
    id: 'hgLipS',
  },
  grid: {
    description: 'Option in display mode dropdown for grid view',
    defaultMessage: 'Grid',
    id: 'JxqgGb',
  },
  blank: {
    description: 'Option in display mode dropdown for blank view',
    defaultMessage: 'Blank',
    id: '+Gr8+e',
  },
});
